import { Image } from '@/components'
import { Box, Stack, SxProps, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
type Props = {
  authorName: string
  children: React.ReactNode
  sx?: SxProps<Theme>
}

export const AvtAuthor = ({ authorName, children, sx }: Props) => {
  return (
    <Stack direction="row" spacing={{ sm: 1, xs: 0.5 }} alignItems="center" sx={{ mt: 1, mb: 2, ...sx }}>
      <Box sx={{ width: { sm: 24, xs: 20 }, aspectRatio: '1/1', flexShrink: 0 }}>
        <Image src={'/assets/icons/favicon.png'} alt={authorName} />
      </Box>

      <Stack direction="row" spacing={0.5} alignItems="center" sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {authorName}
        </Typography>
        <Box sx={{ width: 16, height: 16 }}>
          <img src="/assets/icons/verified.png" alt="verified" width={16} height={16} />
        </Box>
      </Stack>
      {children}
    </Stack>
  )
}
